import Vue from 'vue'
import Vuex from 'vuex'
import { getByParentId } from "@/api/article"
import { makeTree } from "@/base/utils"
import { getUserInfo } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    state: {
      userInfo: {
        bloginName: '',
      },
      industryList: [],
      industryTree: []
    },
    mutations: {
      SETUSERINFO: (state, val) => {
        state.userInfo = val
      },
      SETINDUSTRYTREE: (state, val) => {
        state.industryList = val
        state.industryTree = makeTree(val)
      }
    },
    actions: {
      async setUserInfo({ commit }, val) {
        await getUserInfo().then(res => {
          if (res.data) {
            commit('SETUSERINFO', res.data)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      getIndustyList({ commit }) {
        getByParentId({}).then(res => {
          commit('SETINDUSTRYTREE', res.data)
        }).catch()
      }
    }
  })
